module.exports = __webpack_public_path__ + "img/framboise_creme_closeup.6f0bd8ad.jpg";